// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hp","advertCardFooter__row":"c-a_hq","advertCardFooter__name":"c-a_hr","advertCardFooter__price":"c-a_hs","advertCardFooter__age":"c-a_ht"};